export enum CurrencyEnum{
  US = 'USD'
}
export interface CurrencyMapI {
  [key: string]: string;
}
